// extracted by mini-css-extract-plugin
export var copyableField = "_qz-4";
export var customerBadge = "_qz-0";
export var customerInfoTitle = "_qz-2";
export var details = "_qz-1";
export var dropdownContainer = "_qz-5";
export var dropdownImage = "_qz-6";
export var editAssigneeForm = "_qz-a";
export var editButton = "_qz-3";
export var email = "_qz-7";
export var hidden = "_qz-d";
export var input = "_qz-8";
export var saveButton = "_qz-b";
export var shopifyIcon = "_qz-c";
export var suggestionBadge = "_qz-e";
export var suggestionText = "_qz-f";
export var username = "_qz-9";